import React from "react";

export default function ButtonLight({ 
  onClick, 
  children, 
  className = "" 
}: { 
  onClick: () => void,
  children: React.ReactNode,
  className?: string 
}) {
  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2.5 rounded-md border-0 px-5 py-2 text-sm font-normal leading-[1.4] text-black no-underline shadow-[rgba(0,0,0,0.2)_0px_4px_6px_2px] bg-white cursor-pointer transition-all ${className}`}
    >
      {children}
    </button>
  );
}
